import { html } from 'lit';

export const orgInfo = (orgName: string, orgAddress?: string) => {
	const name = () => html`
		<p><strong>${orgName}</strong></p>
	`;

	const address = () =>
		orgAddress &&
		html`
			<p class="text-xs">${orgAddress}</p>
		`;

	return html`
		<div class="flex flex-col space-y-6">${name()} ${address()}</div>
	`;
};
